import { RefObject } from 'react';
import { useTranslation } from 'react-i18next';

import SearchIcon from '@mui/icons-material/Search';

import {
  SearchInput,
  SearchInputContainer,
  ToolbarIconButton,
} from './GeneratikTableToolbar.styles';

interface ToolbarSearchProps {
  searchOpen: boolean;
  localSearchValue: string;
  searchInputRef: RefObject<HTMLInputElement | null>;
  placeholder?: string;
  onSearchClick: () => void;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearchBlur: () => void;
  onSearchKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const ToolbarSearch = ({
  searchOpen,
  localSearchValue,
  searchInputRef,
  placeholder,
  onSearchClick,
  onSearchChange,
  onSearchBlur,
  onSearchKeyDown,
}: ToolbarSearchProps) => {
  const { t } = useTranslation();

  return (
    <>
      {!searchOpen && (
        <ToolbarIconButton onClick={onSearchClick} data-testid="table-search-toggle">
          <SearchIcon />
        </ToolbarIconButton>
      )}
      <SearchInputContainer open={searchOpen} data-testid="table-search">
        <SearchInput
          data-testid="table-search-input"
          ref={searchInputRef}
          type="text"
          value={localSearchValue}
          onChange={onSearchChange}
          onBlur={onSearchBlur}
          onKeyDown={onSearchKeyDown}
          placeholder={placeholder || t('Search...')}
        />
      </SearchInputContainer>
    </>
  );
};

export default ToolbarSearch;
